import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import styles from "../../styles/common/chip.module.css";
import { Tooltip } from "@mui/material";

type FundingStatusProps = {
  isFunded: boolean;
  percent: number;
  sponsored_by_leftovers?: boolean;
};
const FundingStatusChip = (props: FundingStatusProps) => {
  return (
    <Chip
      className={props.isFunded ? styles.chipFunded : styles.chip}
      icon={
        props.isFunded ? (
          <CheckCircleIcon color="secondary" />
        ) : (
          <CheckCircleOutlineOutlinedIcon color="primary" />
        )
      }
      label={
        props.isFunded ? (
          props.sponsored_by_leftovers ? (
            <Tooltip title="Proposal was sponsored through leftover funds">
              <Typography className={styles.chipLabel} textAlign="center">
                Funded
                <sup style={{ fontSize: "12px", marginTop: "-5px" }}>*</sup> |
                Received {props.percent!.toFixed(2)} % of challenge amount.
              </Typography>
            </Tooltip>
          ) : (
            <Typography className={styles.chipLabel}>
              Funded | Received {props.percent!.toFixed(2)} % of challenge
              amount.
            </Typography>
          )
        ) : (
          <Typography className={styles.chipLabel}>
            Not Funded | Requested {props.percent!.toFixed(2)}% of challenge
            amount.
          </Typography>
        )
      }
    />
  );
};

export default FundingStatusChip;
